const CACHE_PREFIX = 'ezy_cache_';

export const getCached = (key) => {
  try {
    const item = sessionStorage.getItem(CACHE_PREFIX + key);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
};

export const setCache = (key, data) => {
  try {
    sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify(data));
  } catch {
    // sessionStorage full or data too large — silently skip
  }
};

export const removeCache = (key) => {
  sessionStorage.removeItem(CACHE_PREFIX + key);
};

export const removeCacheByPrefix = (prefix) => {
  const fullPrefix = CACHE_PREFIX + prefix;
  for (let i = sessionStorage.length - 1; i >= 0; i--) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(fullPrefix)) {
      sessionStorage.removeItem(key);
    }
  }
};

export const clearApiCache = () => {
  for (let i = sessionStorage.length - 1; i >= 0; i--) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(CACHE_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  }
};
